import React from "react";
import "./styles/style.css";
import LandingPage from "./components/LandingPage";
import WorkPage from "./components/WorkPage";
import AboutPage from "./components/About";
import Project from "./components/Projects";
import ErrorPage from "./components/Error404";
import { OnGoingProvider } from "./components/ProjectContext/OnGoingContext";
import { FullStackProvider } from "./components/ProjectContext/FullStackContext";
import { UIDProvider } from "./components/ProjectContext/UIdesignContext";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const App = () => {
  return (
    <React.Fragment>
      <Router>
        <OnGoingProvider>
          <FullStackProvider>
            <UIDProvider>
              <Switch>
                <Route path="/" exact component={LandingPage} />
                <Route path="/work" component={WorkPage} />
                <Route path="/about" component={AboutPage} />
                <Route path="/project/:id" component={Project} />
                <Route component={ErrorPage} />
              </Switch>
            </UIDProvider>
          </FullStackProvider>
        </OnGoingProvider>
      </Router>
    </React.Fragment>
  );
};

export default App;
